export const initialState = () => ({
  reminders: [],
  checkNotificationInterval: null,
});

const state = initialState();

export default state;
